module.exports = __webpack_public_path__ + "img/11.fa37085b.png";